import axios from 'axios';

import {
    attendanceRequest,
    attendanceFail,
    attendanceByDateSuccess,
    attendanceSavedSuccess,
    staffMonthlyAttendanceSuccess
} from '../slices/attendanceSlice';

export const getAttendanceByDate = date => async (dispatch) => {
    try {
        dispatch(attendanceRequest());
        const { data } = await axios.get(`/api/v1/admin/attendance?date=${date}`);
        dispatch(attendanceByDateSuccess(data));
    } catch (error) {
        dispatch(attendanceFail(error.response.data.message));
    }
}

export const saveAttendanceBulk = (date, records) => async (dispatch) => {
    try {
        dispatch(attendanceRequest());
        await axios.put(`/api/v1/admin/attendance/bulk`, { date, records });
        dispatch(attendanceSavedSuccess());
    } catch (error) {
        dispatch(attendanceFail(error.response.data.message));
    }
}

export const getStaffMonthlyAttendance = (staffId, year, month) => async (dispatch) => {
    try {
        dispatch(attendanceRequest());
        const { data } = await axios.get(`/api/v1/admin/attendance/staff/${staffId}?year=${year}&month=${month}`);
        dispatch(staffMonthlyAttendanceSuccess(data));
    } catch (error) {
        dispatch(attendanceFail(error.response.data.message));
    }
}
